<template>
  <div class="d-flex flex-wrap justify-center" :style="containerStyle">
    <router-link
      v-for="category in categories"
      :key="category.label"
      class="text-center tile ma-5"
      :style="{ width: tileWidth }"
      :to="{ name: category.group }"
    >
      <v-btn fab :[iconSize]="true" :color="category.iconColor">
        <v-icon color="white" :[iconSize]="true"> {{ category.icon }}</v-icon>
      </v-btn>
      <div class="subtitle-2 label mt-2 primary--text">{{ category.label }}</div>
    </router-link>
  </div>
</template>

<script>
import menu from '@/data/menu';
import { mapGetters } from 'vuex'

export default {
  props: {
    iconSize: {
      type: String,
      default: 'x-large',
    },
    tileWidth: {
      type: String,
      default: '128px',
    },
    containerStyle: Object,
  },
  data() {
    return {
      cats: [
        {
          label: 'Sales',
          icon: 'attach_money',
          iconColor: 'green',
          group: 'sales',
        },
        {
          label: 'Support',
          icon: 'supervisor_account',
          iconColor: 'orange',
          group: 'support',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['filteredMenu']),
    categories() {
      this.$http.get('/api/user')
      return this.cats.filter(item => {
        return this.filteredMenu(menu[item.group]).length > 0
      });
    }
  },
};
</script>

<style scoped>
.tile {
  text-decoration: none;
  color: black;
}

.tile:hover {
  cursor: pointer;
}

.label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 0.75;
}

.tile:hover .label {
  overflow-wrap: break-word;
  white-space: normal;
  word-wrap: break-word;
  opacity: 1;
}
</style>
